import { UIBox } from '@/components/ui/Box';
import styled from 'styled-components';

export const StyledLinkWrapper = styled(UIBox)`
  position: absolute;
  right: 24px;
  top: 36px;
`;
